import React, { createContext, useState } from "react";

const ProductCacheContext = createContext();
const initialCache = {
  products: [],
  nextCursor: null,
  scrollY: 0,
  categoryId: null,
  showLoadMore: false,
};
export const ProductCacheProvider = ({ children }) => {
  const [productCache, setProductCache] = useState(initialCache);

  const clearProductCache = () => {
    setProductCache(initialCache);
  };

  return (
    <ProductCacheContext.Provider
      value={{ productCache, setProductCache, clearProductCache }}
    >
      {children}
    </ProductCacheContext.Provider>
  );
};

export default ProductCacheContext;
